import { render, staticRenderFns } from "./ilink.vue?vue&type=template&id=4036cb44"
import script from "./ilink.vue?vue&type=script&lang=js"
export * from "./ilink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports